export enum UserRole {
  ADMIN = "admin", // Super admin with full access
  SUBADMIN = "subadmin", // Admin with limited access
  USER = "user", // Regular user
  STORE_EDITOR = "store_editor", // Can edit store data
  STORE_ADMIN = "store_admin", // Can manage store and its data
  STORE_CONFIRMER = "store_confirmer", // Can confirm store data
}

export interface User {
  id?: string;
  email: string;
  password?: string; // hashed
  token?: string;
  role: UserRole;
  createdAt?: Date;
  updatedAt?: Date;
  isActive?: boolean;
  storeId?: string;
}
